
import React, { useContext } from 'react'
import { Segment, Button, Container, Divider, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../../../App/stores/RootStore';

interface DetailParams {
    RequestReviewId: string;
}

const ReadOnly: React.FC<DetailParams> = ({ RequestReviewId }) => {
    const rootStore = useContext(RootStoreContext)
    const { ViewReadOnlyRequestReview } = rootStore.requestReviewStore;
    return (
        <Segment clearing>
            <Header>Review Confirmation</Header>
            <Divider />
            <Container>
                Would you like to View the review in Read Only mode
            </Container>

            <Divider />
            
            <Button
                content="View in Read Only Mode"
                className={'rl-btn'}
                floated='right'
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={() => ViewReadOnlyRequestReview(RequestReviewId)}
                positive
            />
        </Segment>
    )
}
export default observer(ReadOnly);